<template>
	<div class="d-flex align-items-center">
		<div class="flex-grow-1 mr-2">
			<b-row>
				<b-col md="4">
					<b-input v-model="firstName" placeholder="Vorname" @input="emitChangeEvent"/>
				</b-col>
				<b-col md="5">
					<b-input v-model="lastName" placeholder="Nachname" @input="emitChangeEvent"/>
				</b-col>
				<b-col md="3">
					<b-input
						v-model="yearOfBirth"
						placeholder="Geburtsjahr (z.B. 1970)"
						maxlength="4"
						@input="emitChangeEvent"
					/>
				</b-col>
			</b-row>
		</div>
		<div class="d-flex align-items-center">
			<a href="#" :class="['ml-2', {'invisible': isLone}]" @click.prevent="$emit('remove')">
				<Icon icon="minus-circle" color="black" size="1comma5x"/>
			</a>
			<a href="#" :class="['ml-2', {'invisible': !isLast || !valid}]" @click.prevent="$emit('add')">
				<Icon icon="plus-circle" color="black" size="1comma5x"/>
			</a>
		</div>
	</div>
</template>

<script>
import {isEmptyOrNull} from "@/helper/String";
import Icon from "@/vue/icon/Icon.vue";
import _ from "lodash";

export default {
	components: {Icon},

	props: {
		item: {
			type: Object,
			required: true
		},
		isLast: {
			type: Boolean,
			required: true,
		},
		isLone: {
			type: Boolean,
			required: true,
		},
	},

	data ()
	{
		return {
			firstName: this.item.firstName || '',
			lastName: this.item.lastName || '',
			yearOfBirth: this.item.yearOfBirth || '',
		};
	},

	computed: {
		yearOfBirthValid ()
		{
			const yearOfBirth = _.trim(this.yearOfBirth);

			return !isEmptyOrNull(yearOfBirth) && /^\d{4}$/.test(yearOfBirth);
		},
		valid ()
		{
			return !isEmptyOrNull(this.firstName)
				&& !isEmptyOrNull(this.lastName)
				&& this.yearOfBirthValid;
		}
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('change', {
				firstName: _.trim(this.firstName),
				lastName: _.trim(this.lastName),
				yearOfBirth: _.trim(this.yearOfBirth),
				valid: this.valid
			});
		}
	}
}
</script>
